
import CompanyOrderList from 'Containers/Billing/CompanyOrderList';
import CompanyOrder from 'Containers/Billing/CompanyOrder';
import BulkCreateOrders from 'Containers/Billing/BulkCreateOrders';
import CopyOrdersToNextYear from 'Containers/Billing/CopyOrdersToNextYear';
import ServiceList from 'Containers/Billing/ServiceList';
import ServiceAdd from 'Containers/Billing/ServiceAdd';
import CompanyIssueInvoiceList from 'Containers/Billing/CompanyIssueInvoiceList';
import CompanyIssueInvoice from 'Containers/Billing/CompanyIssueInvoice';
import BulkCreateIssueInvoices from 'Containers/Billing/BulkCreateIssueInvoices';
import CompanyPaymentList from 'Containers/Billing/CompanyPaymentList';
import CompanyPayment from 'Containers/Billing/CompanyPayment';
import CompanyFinanceSummaryList from 'Containers/Billing/CompanyFinanceSummaryList';
import ServiceWiseBillingSummaryList from 'Containers/Billing/ServiceWiseBillingSummaryList';
import CoordinatorWiseReportList from 'Containers/Billing/CoordinatorWiseReportList';
import FinanceDashboard from 'Containers/Billing/FinanceDashboard';
import CompanyBillingConfigList from 'Containers/Billing/CompanyBillingConfigList';
import CompanyBillingConfigAdd from 'Containers/Billing/CompanyBillingConfigAdd';
import ServicePlanList from 'Containers/Billing/ServicePlanList';
import ServicePlanAdd from 'Containers/Billing/ServicePlanAdd';
import ERPFeaturesDigitalMarketingFeaturesList from 'Containers/Billing/ERPFeaturesDigitalMarketingFeaturesList';
import ERPFeaturesDigitalMarketingFeaturesAdd from 'Containers/Billing/ERPFeaturesDigitalMarketingFeaturesAdd';
import OrdersV2List from 'Containers/OrdersV2/OrdersV2List';
import OrdersV2Form from 'Containers/OrdersV2/OrdersV2Form';
import IdCardTracker from 'Containers/OrdersV2/IdCardTracker';


const Actions = {
    service: {
        view: {
            codenames: [],
            action_code: 'visible_service_view',
            is_superuser_action: false,
            name: 'View Services',
            label: 'Services',
            action: 'action-url',
            url: '/billing/service/list',
            component: <ServiceList />,
            permission_needed: true,
            associated_urls: ['/billing/service'],
        },
        create: {
            codenames: [],
            action_code: 'visible_service_add',
            is_superuser_action: false,
            name: 'Create Services',
            label: 'Services',
            action: 'action-url',
            url: '/billing/service',
            component: <ServiceAdd />,
            permission_needed: true,
        },
        update: {
            codenames: [],
            action_code: 'visible_service_change',
            is_superuser_action: false,
            name: 'Update Services',
            label: 'Services',
            action: 'action',
            permission_needed: true,
        },
        delete: {
            codenames: [],
            action_code: 'visible_service_delete',
            is_superuser_action: false,
            name: 'Delete Services',
            label: 'Services',
            action: 'action',
            permission_needed: true,
        },
        name: 'Services',
        type: 'Billing Setup',
    },
    service_plan: {
        view: {
            codenames: [],
            action_code: 'visible_service_plan_view',
            is_superuser_action: false,
            name: 'View Service Plan',
            label: 'Service Plan',
            action: 'sub-menu',
            url: '/billing/service-plan/list',
            component: <ServicePlanList />,
            permission_needed: true,
            associated_urls: ['/billing/service-plan'],
        },
        create: {
            codenames: [],
            action_code: 'visible_service_plan_add',
            is_superuser_action: false,
            name: 'Create Service Plan',
            label: 'Service Plan',
            action: 'action-url',
            url: '/billing/service-plan',
            component: <ServicePlanAdd />,
            permission_needed: true,
        },
        update: {
            codenames: [],
            action_code: 'visible_service_plan_change',
            is_superuser_action: false,
            name: 'Update Service Plan',
            label: 'Service Plan',
            action: 'action',
            permission_needed: true,
        },
        delete: {
            codenames: [],
            action_code: 'visible_service_plan_delete',
            is_superuser_action: false,
            name: 'Delete Service Plan',
            label: 'Service Plan',
            action: 'action',
            permission_needed: true,
        },
        name: 'Service Plan',
        type: 'Billing Setup',
    },
    company_billing_setup: {
        view: {
            codenames: [],
            action_code: 'visible_company_billing_setup_view',
            is_superuser_action: false,
            name: 'View Company Billing Setup',
            label: 'Company Billing Setup',
            action: 'sub-menu',
            url: '/billing/company-setup/list',
            component: <CompanyOrderList />,
            permission_needed: true,
            associated_urls: ['/billing/company-setup'],
        },
        create: {
            codenames: [],
            action_code: 'visible_company_billing_setup_add',
            is_superuser_action: false,
            name: 'Create Company Billing Setup',
            label: 'Company Billing Setup',
            action: 'action-url',
            url: '/billing/company-setup',
            component: <CompanyOrder />,
            permission_needed: true,
        },
        bulk_create: {
            codenames: [],
            action_code: 'visible_company_billing_setup_add',
            is_superuser_action: false,
            name: 'Create Bulk Orders',
            label: 'Create Bulk Orders',
            action: 'action-url',
            url: '/billing/company-setup/bulk-orders',
            component: <BulkCreateOrders />,
            permission_needed: true,
        },
        update: {
            codenames: [],
            action_code: 'visible_company_billing_setup_change',
            is_superuser_action: false,
            name: 'Update Company Billing Setup',
            label: 'Company Billing Setup',
            action: 'action',
            permission_needed: true,
        },
        delete: {
            codenames: [],
            action_code: 'visible_company_billing_setup_delete',
            is_superuser_action: false,
            name: 'Delete Company Billing Setup',
            label: 'Company Billing Setup',
            action: 'action',
            permission_needed: true,
        },
        name: 'Company Billing Setup',
        type: 'Orders and Invoices',
    },
    company_issue_invoice: {
        view: {
            codenames: [],
            action_code: 'visible_company_issue_invoice_view',
            is_superuser_action: false,
            name: 'View Company Issue Invoice',
            label: 'Company Issue Invoice',
            action: 'sub-menu',
            url: '/billing/issue-invoice/list',
            component: <CompanyIssueInvoiceList />,
            permission_needed: true,
            associated_urls: ['/billing/issue-invoice'],
        },
        create: {
            codenames: [],
            action_code: 'visible_company_issue_invoice_add',
            is_superuser_action: false,
            name: 'Create Company Issue Invoice',
            label: 'Company Issue Invoice',
            action: 'action-url',
            url: '/billing/issue-invoice',
            component: <CompanyIssueInvoice />,
            permission_needed: true,
        },
        bulk_create: {
            codenames: [],
            action_code: 'visible_company_issue_invoice_add',
            is_superuser_action: false,
            name: 'Create Bulk Issue Invoices',
            label: 'Company Issue Invoice',
            action: 'action-url',
            url: '/billing/issue-invoice/bulk-create',
            component: <BulkCreateIssueInvoices />,
            permission_needed: true,
        },
        update: {
            codenames: [],
            action_code: 'visible_company_issue_invoice_change',
            is_superuser_action: false,
            name: 'Update Company Issue Invoice',
            label: 'Company Issue Invoice',
            action: 'action',
            permission_needed: true,
        },
        delete: {
            codenames: [],
            action_code: 'visible_company_issue_invoice_delete',
            is_superuser_action: false,
            name: 'Delete Company Issue Invoice',
            label: 'Company Issue Invoice',
            action: 'action',
            permission_needed: true,
        },
        name: 'Company Issue Invoice',
        type: 'Orders and Invoices',
    },
    company_billing_config: {
        view: {
            codenames: [],
            action_code: 'visible_company_billing_config_view',
            is_superuser_action: false,
            name: 'View Company Billing Config',
            label: 'Company Billing Config',
            action: 'sub-menu',
            url: '/billing/company-billing-config/list',
            component: <CompanyBillingConfigList />,
            permission_needed: true,
            associated_urls: ['/billing/company-billing-config'],
        },
        create: {
            codenames: [],
            action_code: 'visible_company_billing_config_add',
            is_superuser_action: false,
            name: 'Create Company Billing Config',
            label: 'Company Billing Config',
            action: 'action-url',
            url: '/billing/company-billing-config',
            component: <CompanyBillingConfigAdd />,
            permission_needed: true,
        },
        name: 'Company Billing Config',
        type: 'Billing Setup',
    },
    copy_orders_to_next_year: {
        view: {
            codenames: [],
            action_code: 'visible_copy_orders_to_next_year_view',
            is_superuser_action: false,
            name: 'View Copy Orders to Next Year',
            label: 'Copy Orders to Next Year',
            action: 'sub-menu',
            url: '/billing/copy-orders-to-next-year',
            component: <CopyOrdersToNextYear />,
            permission_needed: true,
        },
        name: 'Copy Orders to Next Year',
        type: 'Orders and Invoices',
    },
    company_payment: {
        view: {
            codenames: [],
            action_code: 'visible_company_payment_view',
            is_superuser_action: false,
            name: 'View Company Payment',
            label: 'Company Payment',
            action: 'sub-menu',
            url: '/billing/payment/list',
            component: <CompanyPaymentList />,
            permission_needed: true,
            associated_urls: ['/billing/payment'],
        },
        create: {
            codenames: [],
            action_code: 'visible_company_payment_add',
            is_superuser_action: false,
            name: 'Create Company Payment',
            label: 'Company Payment',
            action: 'action-url',
            url: '/billing/payment',
            component: <CompanyPayment />,
            permission_needed: true,
        },
        update: {
            codenames: [],
            action_code: 'visible_company_payment_change',
            is_superuser_action: false,
            name: 'Update Company Payment',
            label: 'Company Payment',
            action: 'action',
            permission_needed: true,
        },
        delete: {
            codenames: [],
            action_code: 'visible_company_payment_delete',
            is_superuser_action: false,
            name: 'Delete Company Payment',
            label: 'Company Payment',
            action: 'action',
            permission_needed: true,
        },
        name: 'Company Payment',
        type: 'Orders and Invoices',
    },
    company_finance_summary: {
        view: {
            codenames: [],
            action_code: 'visible_company_finance_summary_view',
            is_superuser_action: false,
            name: 'View Company Finance Summary',
            label: 'Company Finance Summary',
            action: 'sub-menu',
            url: '/billing/finance-summary',
            component: <CompanyFinanceSummaryList />,
            permission_needed: true,
            is_superuser_action: true,
        },
        name: 'Company Finance Summary',
        type: 'Reports',
    },
    service_wise_billing_summary: {
        view: {
            codenames: [],
            action_code: 'visible_service_wise_billing_summary_view',
            is_superuser_action: false,
            name: 'View Service Wise Billing Summary',
            label: 'Service Wise Billing Summary',
            action: 'sub-menu',
            url: '/billing/service-wise-finance-summary',
            component: <ServiceWiseBillingSummaryList />,
            permission_needed: true,
            is_superuser_action: true,
        },
        name: 'Service Wise Billing Summary',
        type: 'Reports',
    },
    coordinator_wise_report: {
        view: {
            codenames: [],
            action_code: 'visible_coordinator_wise_report_view',
            is_superuser_action: false,
            name: 'View Coordinator Wise Report',
            label: 'Coordinator Wise Report',
            action: 'sub-menu',
            url: '/billing/coordinator-wise-report',
            component: <CoordinatorWiseReportList />,
            permission_needed: true,
            is_superuser_action: true,
        },
        name: 'Coordinator Wise Report',
        type: 'Reports',
    },
    finance_dashboard: {
        view: {
            codenames: [],
            action_code: 'visible_finance_dashboard_view',
            is_superuser_action: false,
            name: 'View Finance Dashboard',
            label: 'Finance Dashboard',
            action: 'sub-menu',
            url: '/billing/finance-dashboard',
            component: <FinanceDashboard />,
            permission_needed: true,
            is_superuser_action: true,
        },
        name: 'Finance Dashboard',
        type: 'Reports',
    },
    erp_features_digital_marketing_features: {
        view: {
            codenames: [],
            action_code: 'visible_erp_features_digital_marketing_features_view',
            is_superuser_action: false,
            name: 'View ERP Features & Other Services',
            label: 'ERP Features & Other Services',
            action: 'sub-menu',
            url: '/billing/erp-features-digital-marketing-features/list',
            component: <ERPFeaturesDigitalMarketingFeaturesList />,
            permission_needed: true,
            is_superuser_action: true,
        },
        create: {
            codenames: [],
            action_code: 'visible_erp_features_digital_marketing_features_add',
            is_superuser_action: false,
            name: 'Create ERP Features & Other Services',
            label: 'ERP Features & Other Services',
            action: 'action-url',
            url: '/billing/erp-features-digital-marketing-features/add',
            component: <ERPFeaturesDigitalMarketingFeaturesAdd />,
            permission_needed: true,
        },
        update: {
            codenames: [],
            action_code: 'visible_erp_features_digital_marketing_features_change',
            is_superuser_action: false,
            name: 'Update ERP Features & Other Services',
            label: 'ERP Features & Other Services',
            action: 'action-url',
            url: '/billing/erp-features-digital-marketing-features/edit',
            component: <ERPFeaturesDigitalMarketingFeaturesAdd />,
            permission_needed: true,
        },
        delete: {
            codenames: [],
            action_code: 'visible_erp_features_digital_marketing_features_delete',
            is_superuser_action: false,
            name: 'Delete ERP Features & Other Services',
            label: 'ERP Features & Other Services',
            action: 'action',
            permission_needed: true,
        },
        name: 'ERP Features & Other Services',
        type: 'Billing Setup',
    },
    orders_v2: {
        view: {
            codenames: [],
            action_code: 'visible_orders_v2_view',
            is_superuser_action: false,
            name: 'View Orders V2',
            label: 'Orders V2',
            action: 'sub-menu',
            url: '/billing/orders-v2/list',
            component: <OrdersV2List />,
            permission_needed: true,
            associated_urls: ['/billing/orders-v2/form'],
        },
        create: {
            codenames: [],
            action_code: 'visible_orders_v2_add',
            is_superuser_action: false,
            name: 'Create Order V2',
            label: 'Orders V2',
            action: 'action-url',
            url: '/billing/orders-v2/form',
            component: <OrdersV2Form />,
            permission_needed: true,
        },
        update: {
            codenames: [],
            action_code: 'visible_orders_v2_change',
            is_superuser_action: false,
            name: 'Update Order V2',
            label: 'Orders V2',
            action: 'action',
            permission_needed: true,
        },
        delete: {
            codenames: [],
            action_code: 'visible_orders_v2_delete',
            is_superuser_action: false,
            name: 'Delete Order V2',
            label: 'Orders V2',
            action: 'action',
            permission_needed: true,
        },
        name: 'Orders V2',
        type: 'Orders and Invoices',
    },
    id_card_orders: {
        view: {
            codenames: [],
            action_code: 'visible_id_card_orders_view',
            is_superuser_action: false,
            name: 'View ID Card Orders',
            label: 'ID Card Orders',
            action: 'sub-menu',
            url: '/billing/orders-v2/id-cards',
            component: <IdCardTracker />,
            permission_needed: true,
        },
        name: 'ID Card Orders',
        type: 'Orders and Invoices',
    }
}

export default Actions;
